// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"5090":"wix-bookings-services-preferences-modal","5965":"Scheduling","8599":"Gallery"}[chunkId] || chunkId) + ".chunk.min.css";
};